import { TextField } from "@mui/material";
import { useState, useEffect } from "react";
import { showNotification } from "../../store/Central/selectors";
import { useUserManagementStore } from "../../store/UserManagement";
import { EmptyProfileData } from "../../store/UserManagement/user-management.store";
import { Button } from "../../components/ui/button";

export const EmptyProfileUpdateForm: React.FC<{
	emptyProfileId: string;
	onClose: () => void;
}> = ({ emptyProfileId, onClose }) => {
	const { getEmptyProfile, updateEmptyProfile, getMembers } = useUserManagementStore((state) => ({
		getEmptyProfile: state.getEmptyProfile,
		updateEmptyProfile: state.updateEmptyProfile,
		getMembers: state.getMembers,
	}));

	const [emptyProfile, setEmptyProfile] = useState<EmptyProfileData>({
		id: emptyProfileId,
		code: "",
		first_name: "",
		last_name: "",
	});
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const loadEmptyProfile = async () => {
			const data = await getEmptyProfile(emptyProfileId);

			if (!data) {
				showNotification({
					message: "Fehler beim Laden des Profils.",
					type: "error",
				});
				return;
			}

			setEmptyProfile(data);
			setLoading(false);
		};

		loadEmptyProfile();
	}, [emptyProfileId, getEmptyProfile]);

	const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();

		const success = await updateEmptyProfile(emptyProfileId, {
			code: emptyProfile?.code,
			first_name: emptyProfile?.first_name,
			last_name: emptyProfile?.last_name,
		});

		if (!success) {
			showNotification({
				message: "Fehler beim Aktualisieren des Profils.",
				type: "error",
			});
			return;
		}

		showNotification({
			message: "Profil erfolgreich aktualisiert.",
			type: "success",
		});

		await getMembers();
		onClose();
	};

	if (loading) {
		return <div className="py-4 text-center text-gray-500">Laden...</div>;
	}

	return (
		<form onSubmit={handleSubmit} className="space-y-4">
			<TextField
				onChange={(e) => setEmptyProfile({ ...emptyProfile, code: e.target.value } as EmptyProfileData)}
				value={emptyProfile?.code}
				name="code"
				label="Code"
				size="small"
				fullWidth
				variant="outlined"
			/>

			<TextField
				onChange={(e) => setEmptyProfile({ ...emptyProfile, first_name: e.target.value } as EmptyProfileData)}
				value={emptyProfile?.first_name}
				name="first_name"
				label="Vorname"
				size="small"
				fullWidth
				variant="outlined"
			/>

			<TextField
				onChange={(e) => setEmptyProfile({ ...emptyProfile, last_name: e.target.value } as EmptyProfileData)}
				value={emptyProfile?.last_name}
				name="last_name"
				label="Nachname"
				size="small"
				fullWidth
				variant="outlined"
			/>

			<div className="flex justify-end gap-2 pt-4">
				<Button type="button" variant="outline" onClick={onClose}>
					Abbrechen
				</Button>
				<Button type="submit">
					Speichern
				</Button>
			</div>
		</form>
	);
};
